<template>
  <v-card flat>
    <v-card-text>
      <v-form @submit.prevent="onSearch">
        <v-text-field
          v-model.trim="query"
          dense
          :disabled="disabled"
          outlined
          rounded
          :placeholder="placeholder || $t('labels.search')"
        >
          <template #prepend>
            <the-search-bar-filter
              :sorts="sorts"
              :on-sorting="onSorting"
            />
          </template>
          <template #prepend-inner>
            <v-icon>{{ mdiMagnify }}</v-icon>
          </template>
          <template #append>
            <v-btn
              icon
              @click="onReset"
            >
              <v-icon>{{ mdiClose }}</v-icon>
            </v-btn>
          </template>
          <template #append-outer>
            <the-search-bar-eye
              :positions="positions"
              :on-positioning="onPositioning"
            />
          </template>
        </v-text-field>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import TheSearchBarEye from './TheSearchBarEye';
import TheSearchBarFilter from './TheSearchBarFilter';

import { mdiClose, mdiMagnify } from '@mdi/js';

export default {
  name: 'TheSearchBar',
  components: {
    TheSearchBarEye,
    TheSearchBarFilter,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    positions: {
      type: Array,
      default: () => [],
      note: 'List of available positions',
    },
    sorts: {
      type: Array,
      default: () => [],
      note: 'List of available sorts',
    },
  },
  emits: ['positioning-view', 'searching', 'sorting-list'],
  data() {
    return {
      query: '',
    };
  },
  created() {
    this.mdiClose = mdiClose;
    this.mdiMagnify = mdiMagnify;
  },
  methods: {
    onPositioning(value) {
      this.$emit('positioning-view', value);
    },
    onReset() {
      this.query = '';
      this.$emit('searching', this.query);
    },
    onSearch() {
      this.$emit('searching', this.query);
    },
    onSorting(value) {
      this.$emit('sorting-list', value);
    },
  },
};
</script>
